angular
    .module('util.dragdrop')
    .directive('trsNinePicDrag', [function(){
        return {
            scope: {
                pics: '=',
                onDragStart: '&',
                onDragEnd: '&',
                deletePicture: '&',
                addPicture: '&',
                onDragOver: '&',
                onDragLeave: '&',
                onDrop: '&',
                onDrag: '&',
                max: '@'
            },
            restrict: 'E',
            templateUrl: './components/util/trsNinePicDrag/trsNinePicDrag_tpl.html',
            replace: false,
            link: function(scope, element, attr) {
                initStatus();

                /**
                 * [initStatus 初始化状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.status = {
                        dragging: false,
                        curOverIndex: -1,
                        movingIndex: -1,
                    };
                    scope.max = scope.max || 9;
                }

                scope.dragStart = function() {
                    scope.status.dragging = true;
                };

                scope.dragEnd = function() {
                    scope.status.dragging = false;
                    scope.status.curOverIndex = -1;
                    scope.status.movingIndex = -1;
                };
        
                scope.getIndex = function(evt, index) {
                    if ($(evt.target).hasClass('delete')) {
                        scope.moveIndex = index;
                        scope.status.movingIndex = index;
                    }
                };

                scope.overCallback = function(evt, index) {
                    if (!$(evt.target).hasClass('resize')){
                        return true;
                    }
                    let curIndex = parseInt($(evt.target).attr('index'));
                    if (curIndex > scope.max - 1){
                        return;
                    }
                    if (curIndex === scope.status.curOverIndex) {
                        return true;
                    }
                    scope.status.curOverIndex = curIndex;
                    return true;
                };

                scope.dropCallback = function(event, index, item, external, type, allowedType) {
                    scope.pics[scope.status.curOverIndex] = scope.pics.splice(scope.moveIndex, 1, scope.pics[scope.status.curOverIndex])[0]; // 数组元素互换位置，用于图片位置交换
                    scope.status.movingIndex = -1;
                    return item;
                };

                scope.deletePic = function(evt, index) {
                    scope.deletePicture()(index);
                };
            }
        };
    }]);
